import React, { ReactElement } from 'react';
import { useSelector , useDispatch } from 'react-redux';
import {
  actions as ElearningPlayerActions,
  ElearningPlayerStateType,
} from '@/components/Player/modules/reducers/elearningPlayer';
import ResourcesView from './ResourcesView';
import './Resources.scss';

import { ResourceType } from '@/modules/types/resource';

export interface ResourcesPropsType {
  data: ResourceType[] | undefined;
}

const Resources = (): ReactElement => {
  const {
    isVisibleResources,
    content: { resources },
  }: ElearningPlayerStateType = useSelector(
    (state: { elearningPlayer: ElearningPlayerStateType }) =>
      state.elearningPlayer,
  );

  const dispatch = useDispatch();
  const closeResourcesHandler = () => {
    dispatch({
      type: ElearningPlayerActions.closeResources.type,
    });
  };

  return (
    <ResourcesView
      isVisible={isVisibleResources}
      resources={resources}
      closeResources={closeResourcesHandler}
    />
  );
};

export default Resources;
